import { brand, palette } from '@/styles/shared';
export const recordingControlsStyles = {
  container: {
    position: 'relative',
    height: '100%',
  },
  endButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    mt: 2,
    mb: 3,
  },
  endButton: {
    backgroundColor: brand.purpleAccent,
    color: 'white',
    fontSize: '12px',
    fontWeight: 600,
    padding: '8px 12px',
    borderRadius: '5px',
    '&:hover': {
      backgroundColor: brand.purpleAccentDark,
    },
  },
  controlsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 3,
    mb: 3,
  },
  pauseButton: {
    width: {
      xs: '60px',
      lg: '66px',
    },
    height: {
      xs: '60px',
      lg: '66px',
    },
    borderRadius: '50%',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  pauseIcon: {
    width: 24,
    height: 24,
  },
  microphoneButton: {
    width: {
      xs: '60px',
      lg: '66px',
    },
    height: {
      xs: '60px',
      lg: '66px',
    },
    borderRadius: '50%',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  microphoneIcon: {
    width: 32,
    height: 32,
  },
  volumeBarContainer: {
    position: 'absolute',
    bottom: '0px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '120px',
    height: '4px',
    backgroundColor: 'rgba(76, 175, 80, 0.15)',
    borderRadius: '2px',
    overflow: 'hidden',
  },
  volumeBar: {
    height: '100%',
    transition: 'width 0.05s ease-out, background-color 0.2s ease',
    borderRadius: '2px',
  },
  timerText: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(50px, -50%)',
    color: palette.mutedText,
    fontSize: '12px',
    fontWeight: 500,
  },
};
